// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Reducer$LiteracyplanetTupperware from "../Reducer.res.mjs";
import * as ContextMaker$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/ContextMaker.res.mjs";
import * as V2ExerciseContext$LiteracyplanetTupperware from "../v2/V2ExerciseContext.res.mjs";
import * as V2ExerciseStateStoreContext$LiteracyplanetTupperware from "../v2/V2ExerciseStateStoreContext.res.mjs";

var ContextSig = {
  name: "V3PunctuationStates"
};

var include = ContextMaker$LiteracyplanetClientFlags.Make(ContextSig);

var Provider = include.Provider;

function appendToKey(dict, key, data) {
  var a = Belt_Option.getWithDefault(Js_dict.get(dict, key), []);
  dict[key] = Belt_Array.concat(a, [data]);
  return dict;
}

function groupCorrectAnswer(correctAnswer) {
  var answerDict = {};
  return Belt_List.reduceWithIndex(correctAnswer, answerDict, (function (dict, curr, i) {
                var match = curr.split(Reducer$LiteracyplanetTupperware.splitChar);
                if (match.length !== 2) {
                  return dict;
                }
                var punct = match[0];
                var $$char = match[1];
                return Belt_Option.mapWithDefault(Reducer$LiteracyplanetTupperware.splitAnswerAtIndex($$char), dict, (function (param) {
                              return appendToKey(dict, param[1], [
                                          param[0],
                                          punct,
                                          i
                                        ]);
                            }));
              }));
}

function groupUsersAnswer(usersAnswer) {
  return Belt_Array.reduceWithIndex(usersAnswer, {}, (function (dict, curr, i) {
                return appendToKey(dict, curr.charId, [
                            curr.index,
                            curr.text,
                            i
                          ]);
              }));
}

function filterDictArrays(dict, f) {
  return Belt_Array.reduce(Object.keys(dict), {}, (function (newDict, key) {
                var array = Js_dict.get(dict, key);
                if (array === undefined) {
                  return newDict;
                }
                var filteredArray = array.filter(function (e) {
                      return Curry._2(f, key, e);
                    });
                if (filteredArray.length !== 0) {
                  newDict[key] = filteredArray;
                  return newDict;
                } else {
                  return newDict;
                }
              }));
}

function filterCond(usersDict, charId, param) {
  var punct = param[1];
  var array = Js_dict.get(usersDict, charId);
  if (array !== undefined) {
    return Belt_Array.some(array, (function (param) {
                  return punct === param[1];
                }));
  } else {
    return false;
  }
}

function makeComparableSortAnswer(correctAnswer, usersAnswer) {
  var answersDict = groupCorrectAnswer(correctAnswer);
  var usersDict = groupUsersAnswer(usersAnswer);
  var newAnswersDict = filterDictArrays(answersDict, (function (param, param$1) {
          return filterCond(usersDict, param, param$1);
        }));
  var newUsersDict = filterDictArrays(usersDict, (function (param, param$1) {
          return filterCond(answersDict, param, param$1);
        }));
  return Belt_Array.reduce(Object.keys(newUsersDict), usersAnswer, (function (usersAnswer, charId) {
                var match = Js_dict.get(newAnswersDict, charId);
                var match$1 = Js_dict.get(newUsersDict, charId);
                if (match === undefined) {
                  return usersAnswer;
                }
                if (match$1 === undefined) {
                  return usersAnswer;
                }
                var zipped = Belt_Array.map(Belt_Array.zip(match, match$1), (function (param) {
                        var match = param[1];
                        return [
                                param[0][0],
                                match[1],
                                match[2]
                              ];
                      }));
                return Belt_Array.reduce(zipped, usersAnswer, (function (usersAnswer, param) {
                              var originalIndex = param[2];
                              var dragOrder = param[0];
                              return Belt_Array.mapWithIndex(usersAnswer, (function (i, ua) {
                                            if (i === originalIndex) {
                                              return {
                                                      punctId: ua.punctId,
                                                      index: dragOrder,
                                                      text: ua.text,
                                                      charId: ua.charId
                                                    };
                                            } else {
                                              return ua;
                                            }
                                          }));
                            }));
              }));
}

function onSetQuestionState(id, questionIndex, dispatch, step, correctAnswer, items) {
  var match = Reducer$LiteracyplanetTupperware.findQuestionState(step);
  if (match !== undefined && typeof match === "object") {
    Belt_Array.forEach(match._0, (function (response) {
            var responsePayload = response._0;
            if (responsePayload.TAG === "BoolResponsePayload") {
              return Curry._1(dispatch, {
                          TAG: "DeleteResponseIdentifier",
                          _0: questionIndex,
                          _1: responsePayload._0
                        });
            }
            throw {
                  RE_EXN_ID: "Match_failure",
                  _1: [
                    "V3PunctuationStates.res",
                    283,
                    8
                  ],
                  Error: new Error()
                };
          }));
  }
  var res = Belt_Array.reduce(Belt_Array.reverse(items), undefined, (function (prevChar, item) {
          var match = item.kind;
          if (typeof match !== "object") {
            switch (match) {
              case "Character" :
                  if (prevChar !== undefined) {
                    return [
                            prevChar[0],
                            item.id,
                            0
                          ];
                  } else {
                    return [
                            [],
                            item.id,
                            0
                          ];
                  }
              case "CharacterEnd" :
                  return prevChar;
              case "PunctuationEnd" :
                  if (prevChar !== undefined) {
                    return prevChar;
                  } else {
                    return [
                            [],
                            item.id,
                            0
                          ];
                  }
              
            }
          } else {
            if (prevChar === undefined) {
              return prevChar;
            }
            var distractor = match.distractor;
            if (!(distractor && match.placed || !distractor)) {
              return prevChar;
            }
            var i = prevChar[2];
            var charId = prevChar[1];
            var ua_punctId = item.id;
            var ua_text = match.useValueForMarking ? item.text : item.id;
            var ua = {
              punctId: ua_punctId,
              index: i,
              text: ua_text,
              charId: charId
            };
            return [
                    Belt_Array.concat([ua], prevChar[0]),
                    charId,
                    i + 1 | 0
                  ];
          }
        }));
  Belt_Option.map(res, (function (param) {
          Belt_Array.forEach(makeComparableSortAnswer(correctAnswer, param[0]), (function (param) {
                  var group = param.punctId;
                  var index = param.index;
                  var drag = param.text;
                  var drop = param.charId;
                  Curry._1(dispatch, {
                        TAG: "SetQuestionState",
                        _0: questionIndex,
                        _1: {
                          TAG: "SetResponse",
                          _0: {
                            TAG: "BoolResponsePayload",
                            _0: {
                              TAG: "Group",
                              _0: group,
                              _1: {
                                TAG: "Index",
                                _0: index,
                                _1: {
                                  TAG: "IdPair",
                                  _0: drag,
                                  _1: drop
                                }
                              }
                            }
                          }
                        },
                        _2: "ResponseMarking"
                      });
                }));
        }));
}

function getPunctuationResponse(questionState, responseId) {
  if (typeof questionState !== "object") {
    return ;
  } else {
    return Belt_Array.reduce(questionState._0, undefined, (function (acc, response) {
                  if (response.TAG === "ToggleResponse") {
                    return acc;
                  }
                  var responsePayload = response._0;
                  if (responsePayload.TAG !== "BoolResponsePayload") {
                    return acc;
                  }
                  var match = responsePayload._0;
                  if (match.TAG === "Group" && match._0 === responseId) {
                    return response;
                  } else {
                    return acc;
                  }
                }));
  }
}

function getPunctuationMarkType(step, responseId) {
  if (typeof step !== "object") {
    return "Unanswered";
  }
  if (step.TAG === "Attempted") {
    return "Unanswered";
  }
  var match = step._0;
  if (typeof match !== "object") {
    throw {
          RE_EXN_ID: "Match_failure",
          _1: [
            "V3PunctuationStates.res",
            351,
            2
          ],
          Error: new Error()
        };
  }
  var incorrectResponses = match._0.incorrectResponses;
  var response = getPunctuationResponse(step._1, responseId);
  if (response !== undefined) {
    return Belt_Option.mapWithDefault(Reducer$LiteracyplanetTupperware.extractAnswer(response), "Unanswered", (function (encodedId) {
                  if (Belt_List.some(incorrectResponses, (function (id) {
                            return id === encodedId;
                          }))) {
                    return "Wrong";
                  } else {
                    return "Correct";
                  }
                }));
  } else {
    return "Correct";
  }
}

function makeCorrectAnswer(items, correctAnswer) {
  var answers = groupCorrectAnswer(correctAnswer);
  var newItems = {
    contents: Belt_Array.concatMany([items])
  };
  var punctuation = Belt_Array.reduce(Object.keys(answers), [], (function (acc, $$char) {
          return Belt_Array.reduce(answers[$$char], acc, (function (acc, param) {
                        var punc = param[1];
                        var punctuation = Belt_Array.reduceWithIndex(newItems.contents, undefined, (function (res, item, i) {
                                if (res !== undefined) {
                                  return res;
                                }
                                var match = item.kind;
                                var text = item.text;
                                var id = item.id;
                                if (typeof match !== "object") {
                                  return res;
                                }
                                var useValueForMarking = match.useValueForMarking;
                                if (useValueForMarking && text === punc || !useValueForMarking && id === punc) {
                                  newItems.contents.splice(i, 1);
                                  return {
                                          id: id,
                                          text: text,
                                          kind: {
                                            TAG: "Punctuation",
                                            placed: true,
                                            useValueForMarking: useValueForMarking,
                                            distractor: match.distractor
                                          }
                                        };
                                } else {
                                  return res;
                                }
                              }));
                        if (punctuation !== undefined) {
                          return Belt_Array.concatMany([
                                      acc,
                                      [[
                                          punctuation,
                                          $$char
                                        ]]
                                    ]);
                        } else {
                          return acc;
                        }
                      }));
        }));
  return Belt_Array.reduce(punctuation, Belt_Array.concatMany([newItems.contents]), (function (acc, param) {
                var $$char = param[1];
                var punctuation = param[0];
                return Belt_Array.reduceWithIndex(acc, Belt_Array.concatMany([acc]), (function (acc, item, i) {
                              var tmp = item.kind;
                              if (typeof tmp !== "object" && tmp === "Character" && item.id === $$char) {
                                acc.splice(i, 0, punctuation);
                                return acc;
                              } else {
                                return acc;
                              }
                            }));
              }));
}

function V3PunctuationStates$Api(props) {
  var questionIndex = props.questionIndex;
  var items = props.items;
  var match = V2ExerciseContext$LiteracyplanetTupperware.use();
  var getCorrectAnswer = match.getCorrectAnswer;
  var match$1 = React.useState(function (param) {
        return "NotInitialised";
      });
  var setShowAnswer = match$1[1];
  var answerVisible = Curry._1(match.isCorrectAnswerVisible, questionIndex);
  V2ExerciseStateStoreContext$LiteracyplanetTupperware.useDispatch();
  var step = Curry._1(match.getStep, questionIndex);
  var isMarked;
  isMarked = typeof step !== "object" || step.TAG === "Attempted" ? false : true;
  var answerItems = React.useRef(undefined);
  React.useEffect((function (param) {
          var configureItems = function (correctItems) {
            if (answerVisible === undefined) {
              return ;
            }
            if (answerVisible) {
              if (typeof step !== "object" || step.TAG === "Attempted") {
                return ;
              } else {
                return Curry._1(setShowAnswer, (function (param) {
                              return {
                                      TAG: "AnswerVisible",
                                      _0: correctItems
                                    };
                            }));
              }
            }
            if (typeof step !== "object") {
              return ;
            }
            if (step.TAG === "Attempted") {
              return ;
            }
            var tmp = step._0;
            if (typeof tmp !== "object") {
              return ;
            }
            var match = step._1;
            if (typeof match !== "object") {
              return ;
            }
            var responseArray = match._0;
            Curry._1(setShowAnswer, (function (param) {
                    return {
                            TAG: "AnswerVisible",
                            _0: makeCorrectAnswer(items, Reducer$LiteracyplanetTupperware.extractAnswers(responseArray))
                          };
                  }));
          };
          var correctItems = answerItems.current;
          if (correctItems !== undefined) {
            configureItems(correctItems);
          } else {
            var correctAnswer = Curry._1(getCorrectAnswer, questionIndex);
            if (correctAnswer !== undefined) {
              var correctItems$1 = makeCorrectAnswer(items, correctAnswer);
              answerItems.current = correctItems$1;
              configureItems(correctItems$1);
            }
            
          }
        }), [answerVisible]);
  return React.createElement(Provider.make, {
              value: {
                getResponseMarkType: (function (param) {
                    return getPunctuationMarkType(step, param);
                  }),
                isMarked: isMarked,
                showAnswer: match$1[0],
                answerVisible: answerVisible
              },
              children: props.children
            });
}

var Api = {
  make: V3PunctuationStates$Api
};

var initialContext = include.initialContext;

var context = include.context;

var P = include.P;

var ContextMakerProviderNotFound = include.ContextMakerProviderNotFound;

var use = include.use;

export {
  ContextSig ,
  initialContext ,
  context ,
  P ,
  Provider ,
  ContextMakerProviderNotFound ,
  use ,
  appendToKey ,
  groupCorrectAnswer ,
  groupUsersAnswer ,
  filterDictArrays ,
  filterCond ,
  makeComparableSortAnswer ,
  onSetQuestionState ,
  getPunctuationResponse ,
  getPunctuationMarkType ,
  makeCorrectAnswer ,
  Api ,
}
/* include Not a pure module */
